import {
  fallbackLocale,
  localeMap,
  locales,
  parseLocale,
} from "@repo/fika-shared/src/locale"
import { detectLocale, navigatorDetector } from "typesafe-i18n/detectors"
import type { Locales } from "@/i18n/i18n-types"
import { loadLocale as loadLocalSync } from "@/i18n/i18n-util.sync"

export const getLanguageLabel = (locale: Locales) => {
  return localeMap[locale] ?? localeMap[fallbackLocale]
}

export function localeFromUrl(): Locales | null {
  if (typeof window === "undefined") return null

  const params = new URLSearchParams(window.location.search)
  return parseLocale(params.get("locale"))
}

export function browserLocale() {
  return detectLocale(
    fallbackLocale,
    [...locales],
    navigatorDetector,
  ) as Locales
}

export function loadLocale(locale: Locales) {
  loadLocalSync(locale)
}
